const fontWeightSemibold = 500;
const getTextLinkTokens = (mainColors) => ({
    textLink: {
        fontWeight: fontWeightSemibold,
        color: {
            default: mainColors.piccolo,
            hover: mainColors.hit,
            visited: mainColors.hit,
        },
    },
});
export default getTextLinkTokens;
